// extracted by mini-css-extract-plugin
export default {"root":"root___wMBT_","leftRight":"leftRight___DAbn0","Slider":"Slider___pdIGj","rightContent":"rightContent___hfpX2","rightContent_inner":"rightContent_inner___oODYO"};